import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface SupplierEditorViewProps {
	supplierRequest: DropdownRequest<SupplierSummary>;
	value: number | number[] | null;
	mode: ControlMode;
	onChange: (suppliers: SupplierSummary | SupplierSummary[]) => void;
	label?: string;
	required?: boolean;
	multi: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	supplierType?: number;
	afterLoad?: (supplier?: SupplierSummary) => void;
}

export class SupplierEditorView extends React.Component<SupplierEditorViewProps, {}> {
	constructor(props: Readonly<SupplierEditorViewProps>) {
		super(props);
	}

	render(): JSX.Element {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Supplier';
		}

		return (
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				model={this.props.value}
				disabled={this.props.mode == 'display'}
				onChanged={(value) => {
					this.props.onChange(value);
				}}
				required={this.props.required}
				multi={this.props.multi}
				request={this.props.supplierRequest}
				keyField="id"
				textField="title"
				cascadeField={this.props.supplierType != null ? 'type' : null}
				cascadeValue={this.props.supplierType != null ? this.props.supplierType : null}
				placeholder="Select a Supplier..."
				afterLoad={this.props.afterLoad}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/parts/supplier-editor.view.tsx